import * as render from './render.pug'
import { onMounted, onBeforeUnmount, onBeforeMount, ref, reactive } from 'vue'
import { autoUpdate, computePosition, offset } from '@floating-ui/vue'
import { vScroll } from '@vueuse/components'
import { useNotificationStore } from '../store.js'
import { you } from '~vueutil/member/wellknown.js'
import { NotificationListItem } from './item/index.js'

export const NotificationList = {
  ...render,
  props: {
    floating: {
      type: Object
    }
  },
  emits: [],
  components: {
    NotificationListItem
  },
  directives: {
    scroll: vScroll
  },
  setup (props, { emit }) {
    const floating = ref(null)
    const floatingStyles = reactive({})
    const {
      loading,
      items,
      next,
      click
    } = useNotificationStore()

    onBeforeMount(async () => {
      await next()
    })

    onMounted(() => {
      const cleanup = autoUpdate(props.floating, floating.value, () => {
        computePosition(props.floating, floating.value, {
          placement: 'bottom-end',
          middleware: [
            offset(11)
          ]
        }).then(function ({ x, y }) {
          Object.assign(floatingStyles, {
            left: `${x}px`,
            top: `${y}px`
          })
        })
      })

      onBeforeUnmount(() => {
        cleanup()
      })
    })

    return {
      you,
      floating,
      floatingStyles,
      click,
      notifications: items,
      loading,
      onScroll ({ arrivedState }) {
        if (arrivedState.bottom) {
          next()
        }
      }
    }
  }
}
